module.exports = __webpack_public_path__ + "static/media/outdoors.1ba10243.jpg";